"use strict";import{IconHelp as e}from"../src/elements/IconHelp.js";import{defineElement as l}from"@spectrum-web-components/base/src/define-element.js";l("sp-icon-help",e);
//# sourceMappingURL=sp-icon-help.js.map
